import React, { FC, useContext } from "react";

import { Context } from "../../store/student";
import { replaceSearchTextAndUrl } from "../../libs/Convert";

import styles from "./RealizationCareer.module.scss";

type Props = {
  state: {
    searching: boolean;
    searchText: string;
  };
};

const RealizationCareer: FC<Props> = ({ state }) => {
  const { contextState } = useContext(Context);

  const renderContent = (content: string) => ({
    dangerouslySetInnerHTML: {
      __html: replaceSearchTextAndUrl(content, state.searchText ?? ""),
    },
  });

  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {contextState.career_feedback_questions_histories.map(question => {
          if (question.realization === null) return null;

          return (
            <li key={question.id} className={styles.item}>
              <div className={styles.inner}>
                <p
                  className={styles.title}
                  {...renderContent(`Q. ${question.title}`)}
                />
                <p
                  className={styles.text}
                  {...renderContent(question.realization.content ?? "")}
                />
                <p className={styles.date}>{question.realization.created_at}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RealizationCareer;
